import { Modal, Stack } from '@mui/material';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState, Fragment } from 'react';

import { InviteUserForm } from '@/components/management/form/InviteUserForm';
import { StyledModal } from '@/components/management/form/formHelpers/StyledModal';
import { StyledButton } from '@/components/management/formElements/StyledButton';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { UserTable } from '@/components/management/table/UserTable';
import {
  backendApiOrganizationsFindAllOptions,
  backendApiUsersCreateMutation,
  backendApiUsersFindAllOptions,
} from '@/modules/api/backend/@tanstack/react-query.gen';
import { useSnackbarStore } from '@/stores/useSnackbarStore';

export const Route = createFileRoute('/_authenticated/management/users/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  beforeLoad: () => ({ breadcrumb: null }),
});
function RouteComponent() {
  const [modalOpen, setModalOpen] = useState(false);

  const { data: organizations } = useSuspenseQuery(backendApiOrganizationsFindAllOptions());

  const { openSnackbar } = useSnackbarStore((state) => state.actions);

  const { mutateAsync } = useMutation({
    ...backendApiUsersCreateMutation(),
    onSuccess: () => {
      openSnackbar({
        color: 'success',
        message: 'Die Einladung wurde erfolgreich versendet!',
      });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError: (error: any) => {
      if (error?.message?.[0]?.constraints?.isUnique) {
        openSnackbar({
          color: 'error',
          message: 'Diese E-Mail-Adresse ist bereits registriert.',
        });
      } else {
        openSnackbar({
          color: 'error',
          message: 'Fehler beim Versenden der Einladung.',
        });
      }
      setModalOpen(false);
    },
  });

  const { data: userData } = useQuery(backendApiUsersFindAllOptions());

  return (
    <Fragment>
      <AdministrationHeader label="User*innen" />
      <AdministrationBody>
        <Stack flex={1} gap={4}>
          {userData ? <UserTable userData={userData} /> : null}
          <Stack alignItems="flex-end">
            <StyledButton label="User*in hinzufügen" onClick={() => setModalOpen(true)} />
          </Stack>
          <Modal aria-labelledby="User*in hinzufügen" onClose={() => setModalOpen(false)} open={modalOpen}>
            <StyledModal>
              <InviteUserForm
                onCancel={() => setModalOpen(false)}
                organizations={organizations}
                onSubmit={async (values) => {
                  await mutateAsync({
                    body: values,
                  });
                  setModalOpen(false);
                }}
              />
            </StyledModal>
          </Modal>
        </Stack>
      </AdministrationBody>
    </Fragment>
  );
}
